export default {
  selectAppPushMessageDetails: '/MedicalCollege/app-push/selectAppPushMessageDetails', //APP消息推送查看详情接口
  selectAppPushMessagePage: '/MedicalCollege/app-push/selectAppPushMessagePage', //APP消息推送列表查询接口
  selectByIdPage: '/MedicalCollege/message/record/selectByIdPage', //根据用户id查询消息记录(分页)
  updateMessageRecord: '/MedicalCollege/message/record/updateMessageRecord',
  insertEquipmentRecord: '/MedicalCollege/equipment/api/insertEquipmentRecord',
  deleteEquipmentRecord: '/MedicalCollege/equipment/api/deleteEquipmentRecord'
}